import { Component, Input, ViewChild, ElementRef } from '@angular/core';
declare var bootstrap: any;

@Component({
  selector: 'app-image-with-text',
  templateUrl: './image-with-text.component.html',
  styleUrls: ['./image-with-text.component.css'],
})
export class ImageWithTextComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  @ViewChild('imageModalRef', { static: true }) imageModalRef!: ElementRef;

  selectedImage: string = '';

  openImage(imagePath: string): void {
    this.selectedImage = imagePath;
    const modalEl = this.imageModalRef.nativeElement;
    const modal = new bootstrap.Modal(modalEl);
    modal.show();
  }

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
